module.exports = __webpack_public_path__ + "a5babbb8610b651cf646e4d9f199e7cc.png";